exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-5d9e20c5]{font-size:.24rem;margin-top:.56rem;color:#97989b;line-height:.36rem;white-space:nowrap;overflow:hidden;padding-bottom:.1rem}.title span[data-v-5d9e20c5]{display:inline-block}.number[data-v-5d9e20c5]{background:#97989b;width:.36rem;height:.36rem;border-radius:50%;display:inline-block;line-height:.36rem;color:#fff;font-size:.24rem;text-align:center;margin-right:.1rem}.number_new[data-v-5d9e20c5]{color:#ff5548}.number_new span[data-v-5d9e20c5]:first-child{background:#ff5548}.status1[data-v-5d9e20c5]{margin-left:2.76rem}.line[data-v-5d9e20c5]{width:.6rem;line-height:.18rem;height:.18rem;border-bottom:1px solid #979797;text-align:center;margin:0 .05rem .09rem}.line3_2[data-v-5d9e20c5]{width:.3rem}.line4_3[data-v-5d9e20c5]{width:.12rem}.line5_4[data-v-5d9e20c5]{width:.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d9e20c5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StatusBar.vue
// module id = +tQc
// module chunks = 1